// extracted by mini-css-extract-plugin
export default {"button":"WhatsAppButton_button__9nFst","floating":"WhatsAppButton_floating__t5AqX","icon":"WhatsAppButton_icon__dSUPM","label":"WhatsAppButton_label__jddw7"};